import React from 'react'
import { Tabs, TabPanel } from '@tencent/spaui-tabs'
import UploadingList from '../UploadingList'
import ProcessingList from '../ProcessingList'
import ProcessManagementTips from 'pureComponents/ProcessManagementTips'
import useProgressManagement from './hooks/useProgressManagement'

const ProgressManagement = () => {
    const {
        handleTabChange,
        LinkButtonComponent,
        activeTab,
        uploadCount,
        setUploadCount,
        processCount,
        setProcessCount,
    } = useProgressManagement()

    return (
        <Tabs
            onChange={handleTabChange}
            value={activeTab}
            className="datalist-tabs sub-tabs"
            LinkComponent={LinkButtonComponent}
            TabCommonComponent={activeTab === '0' ? ProcessManagementTips : null}
        >
            <TabPanel tab={'正在上传' + uploadCount} name="0">
                <div className="spaui-tabs-content">
                    <UploadingList setUploadCount={setUploadCount} />
                </div>
            </TabPanel>
            <TabPanel tab={'校验处理' + (processCount !== 0 ? processCount : '')} name="1">
                <div className="spaui-tabs-content">
                    <ProcessingList setProcessCount={setProcessCount} activeTab={activeTab} />
                </div>
            </TabPanel>
        </Tabs>
    )
}

export default ProgressManagement
